var _metadata, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Svg Vector (c) Genevy Gravitons : https://github.com/Genevy")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#181d1c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.3,425.6a11.4,11.4,0,0,0,16.2.1h.1a11.9,11.9,0,0,0,0-16.6l-82.1-82.9a9.9,9.9,0,0,0-1.1-1.7,11.7,11.7,0,0,0-8.5-3.3,11.8,11.8,0,0,0-8.5,3.3c-.4.5-.6,1.2-1,1.7l-49.8,50.3L253.4,254.2a9.9,9.9,0,0,0-1.1-1.7,12.4,12.4,0,0,0-17,0,9.9,9.9,0,0,0-1.1,1.7L80.8,409a11.8,11.8,0,0,0,1.3,16.6,11.7,11.7,0,0,0,15.1,0L243.8,277.7,414.2,449.6a11.7,11.7,0,0,0,16.6-16.4l-.2-.2L391,393l43-43.5Z",
    transform: "translate(-0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2,189c0-26.5-21.3-48-47.5-48a48,48,0,0,0,0,96h0a47.6,47.6,0,0,0,47.5-47.9ZM339,189a24,24,0,1,1,0,.2Z",
    transform: "translate(-0.4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.1614fe30113127b43e3d9b17aabf49be.svg";
export { ForwardRef as ReactComponent };